export default "__VITE_ASSET__BeKdHrqe__"